import Vue from 'vue';
import { apiLogin, apiAuthListByHost, apiLogout, apiCompanyFindUsedBusiness } from '@/services/ims';
import { Loading } from 'element-ui';
import { Notification } from 'element-ui';

function setWinApi(key, value) {
    if (!window.IMS_API) window.IMS_API = {};
    window.IMS_API[key] = value;
}
function IterPermission(allpermission, phas = false) {
    let res = [];
    allpermission.forEach(x => {
        let p = x.approvalName != null && x.approvalName.length > 0;
        if (p) {
            res.push({ url: 'path' + x.url, value: x.id });
        } else {
            if (phas) res.push({ url: 'path' + x.url, value: x.pid });
        }

        if (x.children && x.children.length > 0) {
            res = res.concat(IterPermission(x.children, p));
        }
    });
    return res;
}

// initial state
const state = {
    BaseInfo: {},
    HostCurrent: {},
    PermissionVoSet: [],
    BtnPermissions: [],
    MenuActive: '',
    ModulesCompleted: [],
    AllPermission: [],
    UsedBusiness: [], // 公司抬头列表
};

// getters
const getters = {
    HostSet: state => state.BaseInfo.hostSet.filter(v => v.status === 1),
};

function getBtnPermission(arr) {
    let res = [];
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].type === 2) {
            res.push(arr[i].url);
        } else if (arr[i].children && arr[i].children.length > 0) {
            let subRes = getBtnPermission(arr[i].children);
            if (subRes.length > 0) {
                res = [...res, ...subRes];
            }
        }
    }
    return res;
}

const actions = {
    /**
     * 用户登录
     * @param {*} param0
     * @param {*} params
     * @returns
     */
    async login({ commit, dispatch }, params) {
        let loadingInstance = Loading.service();
        const res = await apiLogin(params);
        localStorage.setItem('IMS_USER', JSON.stringify(res.data));
        loadingInstance.close();

        if (res.state == 1) {
            if (!res.data.hostSet || res.data.hostSet.length < 1)
                Notification.error({
                    title: `登录失败`,
                    message: '该用户暂无任何权限来访问系统！',
                });
            else await dispatch('initUserInfo');
        } else {
            res.state = -1;
        }
        return res;
    },
    /**
     * 初始化用户信息
     * @param {*} param0
     * @param {*} params
     */
    async initUserInfo({ commit, dispatch, state }) {
        await dispatch('authListByHost');
    },
    /**
     * 获取当前用户模块hostId的所有权限
     * @param {*} param0
     */
    async authListByHost({ state, commit }) {
        const params = JSON.parse(localStorage.getItem('IMS_USER'));
        commit('BaseInfo', params);
        if (!params.hostSet) {
            Notification.error({
                title: '错误',
                message: '该用户没有任何权限',
            });
            return;
        }

        commit('HostCurrent', params.hostSet.length > 0 ? params.hostSet[0] : {});
        const hostId = state.HostCurrent.id;
        const hostCode = params.hostSet.filter(v => v.id === hostId)[0].code;

        const _res = sessionStorage.getItem('Permissions');
        if (!_res || _res == 'undefined') {
            const res1 = await apiAuthListByHost({ hostId });
            sessionStorage.setItem('Permissions', JSON.stringify(res1));
        }
        const res = JSON.parse(sessionStorage.getItem('Permissions'));

        if (res.state == 1) {
            const btns = getBtnPermission(res.data.permissionVoSet || []);
            commit('BtnPermissions', { btns, hostId });
            const permissionVoSet = res.data.permissionVoSet.length > 0 ? res.data.permissionVoSet.map(v => ({ ...v, code: hostCode })) : [];
            commit('PermissionVoSet', { permissionVoSet, hostId });
            commit('AllPermission', { permissionVoSet, hostId });
            commit('ModulesCompleted', hostId);
        }
    },

    /**
     * 获取启用的本公司抬头
     * @param {*} param0
     */
    async findUsedBusiness({ state, commit }) {
        const res = await apiCompanyFindUsedBusiness();
        if (res.state == 1) {
            commit('UsedBusiness', res.data || []);
        }
    },
    /**
     * 退出登录
     * @param {*} param0
     */
    async logout({ commit }) {
        const res = await apiLogout();
        commit('BaseInfo', {});
        commit('MenuActive', '');
        commit('HostCurrent', {});
        commit('BtnPermissions', { btns: [], hostId: '' });
        commit('PermissionVoSet', { permissionVoSet: [], hostId: '' });
        localStorage.clear();
        sessionStorage.clear();
        window.IMS_API = {};
    },
};

// mutations
const mutations = {
    BaseInfo(state, payload) {
        state.BaseInfo = payload;
        setWinApi('user', payload);
    },

    HostCurrent(state, payload) {
        state.HostCurrent = payload;
        setWinApi('curHost', payload);
    },

    BtnPermissions(state, payload) {
        if (!state.ModulesCompleted.includes(payload.hostId)) {
            state.BtnPermissions.push(...payload.btns);
        }
        setWinApi('btnPermissions', state.BtnPermissions);
    },

    PermissionVoSet(state, payload) {
        Vue.prototype.arraySort(payload.permissionVoSet);
        state.PermissionVoSet = payload.permissionVoSet;
        setWinApi('permissionVoSet', state.PermissionVoSet);
    },

    AllPermission(state, payload) {
        if (!state.ModulesCompleted.includes(payload.hostId)) {
            let res = IterPermission(payload.permissionVoSet);
            state.AllPermission.push(...res);
            setWinApi('AllPermission', res);
        }
    },

    MenuActive(state, payload) {
        state.MenuActive = payload;
    },

    ModulesCompleted(state, payload) {
        if (!state.ModulesCompleted.includes(payload)) {
            state.ModulesCompleted.push(payload);
        }
    },

    UsedBusiness(state, payload) {
        state.UsedBusiness = payload;
        setWinApi('UsedBusiness', payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/ImsUsers.js